import React from 'react';
import Header from '../components/Header';
import Pocetna from '../components/Pocetna';
import Footer from '../components/Footer';

function HomePage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <Pocetna />
      </div>
      <Footer />
    </>
  );
}

export default HomePage;
